const { setInitialised, useArrows, useDots } = window.BAO.Carousel.plugins

class CollectionCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.handleGridSwitchClick = this.handleGridSwitchClick.bind(this)
    this.handleCarouselResize = this.handleCarouselResize.bind(this)

    this.currentDesktopView =
      this.externalEls?.currentView?.element.dataset.desktopView
    this.currentMobileView =
      this.externalEls?.currentView?.element.dataset.mobileView

    if (
      (this.currentDesktopView === 'list' && window.innerWidth > 768) ||
      (this.currentMobileView === 'list' && window.innerWidth <= 768) ||
      (this.currentDesktopView === undefined && window.innerWidth > 768) ||
      (this.currentMobileView === undefined && window.innerWidth <= 768)
    ) {
      this.carousel = this.setupCarousel()
      this.els?.poster?.element.classList.add('prd-Card_Image-hidden')
      this.els?.dots?.element.classList.remove('prd-Card_MediaDots-hidden')
    }
  }

  setupListeners () {
    window.addEventListener('plpViewChange', (e) => {
      this.handleGridSwitchClick(e)
    })

    window.addEventListener('carouselResize', (e) =>
      this.handleCarouselResize(e),
    )
  }

  handleCarouselResize (e) {
    this.currentDesktopView =
      this.externalEls?.currentView?.element.dataset.desktopView
    this.currentMobileView =
      this.externalEls?.currentView?.element.dataset.mobileView

    if (this.carousel) {
      this.carousel.destroy()
      this.els?.poster?.element.classList.remove('prd-Card_Image-hidden')
      this.els?.dots?.element.classList.add('prd-Card_MediaDots-hidden')
    }

    if (
      (this.currentDesktopView === 'list' && e.detail.windowWidth > 768) ||
      (this.currentMobileView === 'list' && e.detail.windowWidth <= 768) ||
      (this.currentDesktopView === undefined && e.detail.windowWidth > 768) ||
      (this.currentMobileView === undefined && e.detail.windowWidth <= 768)
    ) {
      this.carousel = this.setupCarousel()
      this.els?.poster?.element.classList.add('prd-Card_Image-hidden')
      this.els?.dots?.element.classList.remove('prd-Card_MediaDots-hidden')
    }
  }

  fixContainerWidth () {
    // Ensure container width results in whole pixel slide widths
    const container = this.els.slides.element

    // Reset width to auto to get natural width
    container.style.width = 'auto'

    // Get current width and round to nearest pixel
    const containerRect = container.getBoundingClientRect()
    const roundedWidth = Math.ceil(containerRect.width)

    // Set explicit width to ensure whole pixels
    container.style.width = `${roundedWidth}px`
  }

  handleGridSwitchClick (e) {
    if (e.detail.view === 'list') {
      this.els?.slides?.element.classList.remove('prd-Card_MediaSlider-hidden')
      this.carousel = this.setupCarousel()
      this.els?.poster?.element.classList.add('prd-Card_Image-hidden')
      this.els?.dots?.element.classList.remove('prd-Card_MediaDots-hidden')
    } else if (e.detail.view === 'grid') {
      if (this.carousel) {
        this.carousel.destroy()
        this.carousel = null
        this.els?.poster?.element.classList.remove('prd-Card_Image-hidden')
        this.els?.dots?.element.classList.add('prd-Card_MediaDots-hidden')
        this.els?.slides?.element.classList.add('prd-Card_MediaSlider-hidden')
      }
    }
  }

  setupCarousel () {
    this.fixContainerWidth()

    const slider = new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        draggable: true,
        slides: {
          perView: 1,
          spacing: 0,
        },
        defaultAnimation: { duration: 0 },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        useDots(this.els?.dot?.elements),
      ],
    )

    this.setupAccessibility(slider)

    return slider
  }

  setupAccessibility (slider) {
    // Update accessibility attributes when slide changes
    const updateA11y = () => {
      const slides = slider.slides
      const activeIndex = slider.track.details.rel

      slides.forEach((slide, index) => {
        const link = slide.querySelector(
          '[data-collection-page-carousel-el="fauxlink"]',
        )
        if (link) {
          if (index === activeIndex) {
            link.removeAttribute('aria-hidden')
            link.removeAttribute('tabindex')
          } else {
            if (document.activeElement === link) {
              link.blur()
            }
            link.setAttribute('aria-hidden', 'true')
            link.setAttribute('tabindex', '-1')
          }
        }
      })
    }

    updateA11y()

    // Update on slide changes
    slider.on('slideChanged', updateA11y)
    slider.on('created', updateA11y)

    // Also update before slide changes to handle focus properly
    slider.on('beforeSlideChanged', () => {
      const slides = slider.slides
      slides.forEach((slide) => {
        const link = slide.querySelector(
          '[data-collection-page-carousel-el="fauxlink"]',
        )
        if (link && document.activeElement === link) {
          link.blur()
        }
      })
    })
  }
}

if (!customElements.get('collection-page-carousel')) {
  customElements.define('collection-page-carousel', CollectionCarousel)
}
